import { Element } from '@shared/interfaces/element.interface';
import React from 'react';
import idGovUaLightIcon from '@assets/icons/id-gov-ua-dark.svg';
import { useTranslation } from 'react-i18next';

interface Props extends Element {
  isLogoVisible?: boolean;
  iconClassName?: string;
}

function useComponentState(props: Props) {
  const { t } = useTranslation();
  const { iconClassName = '' } = props;
  const iconClass = `object-contain select-none ${iconClassName}`;
  const titleTranslated = t('id-gov-ua-verified');

  return {
    iconClass,
    titleTranslated,
    ...props,
  };
}

export const IdGovUaLogo: React.FC<Props> = (props) => {
  const { isLogoVisible = true, className, iconClass, titleTranslated } = useComponentState(props);

  if (!isLogoVisible) return null;

  return (
    <div className={`flex-shrink-0 ${className}`}>
      <img src={idGovUaLightIcon} width="80" height="10" className={iconClass} title={titleTranslated} />
    </div>
  );
};
